import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";
import accountingImg1 from "../assets/images/accountingimg1.jpg";

// A simple Bootstrap-based Card component
function Card({ children, className = "", style = {}, onClick }) {
    return (
        <div
            className={`card ${className}`}
            style={{
                position: "relative",
                overflow: "hidden",
                cursor: onClick ? "pointer" : "default",
                ...style,
            }}
            onClick={onClick}
        >
            {children}
        </div>
    );
}

function CardContent({ children, className = "", style = {} }) {
    return (
        <div className={`card-body ${className}`} style={style}>
            {children}
        </div>
    );
}

// Industry data
const INDUSTRIES = [
  {
    title: "Business Courses",
    image:
      "https://www.businessbpo.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fbusiness-bpo-virtual-assistance.bd8b9c2e.webp&w=1920&q=75",
    bgColor: "#2B6CB0",
    link: "/professional-business-courses",
    content: {
      leftTitle: "Entrepreneurship and Business Skills Development",
      leftDescription:
        "Our business courses are designed to equip participants with practical skills in business planning, marketing, finance, and operations. Learn how to launch, grow, and manage a successful business in today’s competitive market.",
      rightTitle: "Ideal For",
      points: [
        "Aspiring Entrepreneurs",
        "Startup Founders",
        "Small Business Owners",
        "MBA Students",
        "Freelancers and Consultants",
      ],
    },
  },
  {
    title: "Accounting Training",
    image: accountingImg1, // ✅ Local image
    link: "/accounting-course",
    content: {
      leftTitle: "Professional Accounting Certificate Courses",
      leftDescription:
        "Postgraduate Diploma in Project Management (PGDPM) has been specifically designed as an advanced course for working professionals who want to take on challenges as highly effective project leaders. The Project Management course also focuses on project management methodology that will allow you to initiate and manage a project efficiently and effectively. Participants will learn key project management skills and strategies.",
      rightTitle: "What We Offer",
      points: [
        "Fresh Graduates",
        "Small Business Owners",
        "Entrepreneurs",
        "Job Seekers in the Finance Sector",
        "Mid-level Accounting Professionals",
      ],
    },
  },
  {
    title: "Taxation Courses",
    image:
      "https://www.businessbpo.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fbusiness-bpo-accounting-service.8bc34464.jpg&w=1920&q=75",
    bgColor: "#E53E3E",
    link: "/professional-taxation-training",
    content: {
      leftTitle: "Professional Taxation Certificate Courses",
      leftDescription:
        "This course is designed for professionals and business owners who want to master the principles of income tax, VAT, and corporate tax. Participants will learn how to file returns, handle audits, and maintain compliance with the latest NBR regulations.",
      rightTitle: "Who Should Join?",
      points: [
        "Accounting Professionals",
        "Corporate Finance Officers",
        "Tax Consultants",
        "Small Business Owners",
        "Audit Professionals",
      ],
    },
  },
  {
    title: "Management Courses",
    image:
      "https://www.businessbpo.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fsocial-media-marketing.625a5c6a.jpg&w=1920&q=75",
    bgColor: "#805AD5",
    link: "/professional-management-training",
    content: {
      leftTitle: "Leadership and Management Development Program",
      leftDescription:
        "This program is tailored for professionals aiming to improve their leadership, communication, team management, and decision-making skills. Ideal for individuals transitioning into managerial roles or aiming for career advancement.",
      rightTitle: "Best For",
      points: [
        "New Managers",
        "Team Leaders",
        "Supervisors",
        "Project Managers",
        "Department Heads",
      ],
    },
  },
];


export default function IndustryShowcase() {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleIndustry = (index) => {
        setActiveIndex((prev) => (prev === index ? null : index));
    };

    return (
        <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="container py-4"
        >
            <div style={{ marginBottom: "60px" }} className="container-xxl text-center">
                <h1 style={{ marginBottom: "5px" }}>Grow your career with professional training !</h1>
                <p className="fs-5 text-center">
                    Our knowledge ​and practical professional courses to get you hired.
                </p>
                <Link
                    to="/training"
                    className="btn btn-primary fs-3"
                    style={{ width: "215px" }}
                >
                    Get Started
                </Link>
            </div>

            {/* Card Grid */}
            <div className="row">
                {INDUSTRIES.map((industry, idx) => {
                    const isActive = activeIndex === idx;
                    return (
                        <div key={idx} className="col-12 col-md-6 col-lg-3 mb-4">
                            <Card
                                onClick={() => toggleIndustry(idx)}
                                className={isActive ? "border border-warning" : ""}
                                style={{ height: "300px" }}
                            >
                                {/* Background image and overlay */}
                                <div
                                    style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        backgroundImage: `url(${industry.image})`,
                                        backgroundSize: "cover",
                                        backgroundPosition: "center",
                                        filter: "brightness(70%)",
                                        transition: "transform 0.5s",
                                    }}
                                />
                                <CardContent
                                    style={{
                                        position: "relative",
                                        zIndex: 2,
                                        color: "#4caf50",
                                        height: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <h5
                                        style={{
                                            background: "#4caf50",
                                            color: "white",
                                            fontSize: "18px",
                                        }}
                                        className="card-title"
                                    >
                                        {industry.title}
                                    </h5>
                                    <div className="d-flex justify-content-end">
                                        <div
                                            style={{
                                                width: "32px",
                                                height: "32px",
                                                background: "white",
                                                borderRadius: "50%",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                transition: "transform 0.3s",
                                                transform: isActive ? "rotate(180deg)" : "rotate(0deg)",
                                            }}
                                        >
                                            <ChevronDown color="#000" size={16} />
                                        </div>
                                    </div>
                                </CardContent>
                            </Card>
                        </div>
                    );
                })}
            </div>

            {/* Expanded Industry Detail */}
            {activeIndex !== null && (
                <Card className="border border-success mt-4">
                    <CardContent>
                        <div className="row">
                            <div className="col-md-7">
                                <h3>{INDUSTRIES[activeIndex].content.leftTitle}</h3>
                                <p>{INDUSTRIES[activeIndex].content.leftDescription}</p>
                                <Link
                                    to={INDUSTRIES[activeIndex].link}
                                    style={{ background: "#4caf50", color: "white" }}
                                    className="btn"
                                >
                                    Discover More
                                </Link>
                            </div>
                            <div className="col-md-5">
                                <h4>{INDUSTRIES[activeIndex].content.rightTitle}:</h4>
                                <ul className="list-unstyled">
                                    {INDUSTRIES[activeIndex].content.points.map((point, pidx) => (
                                        <li key={pidx} className="mb-2">
                                            <span style={{ background: "#4caf50" }} className="badge me-2">
                                                &nbsp;
                                            </span>
                                            {point}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </CardContent>
                </Card>
            )}
        </motion.div>
    );
}
